export default __webpack_public_path__ + "schedule-md.09a12120.svg";